import React from 'react';
import { motion } from 'framer-motion';
import { MapPinIcon, PhoneIcon, ClockIcon, NavigationIcon } from 'lucide-react';
export function LocalAuthority() {
  return <section id="visit" className="section-padding bg-background" data-id="element-435">
      <div className="container-custom" data-id="element-436">
        <div className="grid lg:grid-cols-12 gap-12 items-start" data-id="element-437">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} className="lg:col-span-5" data-id="element-438">
            <span className="eyebrow" data-id="element-439">Visit the workshop</span>
            <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-medium leading-[1.1] mb-7 text-balance" data-id="element-440">
              Your local jeweller, south of the river —{' '}
              <span className="italic text-gold-dark" data-id="element-441">
                in the same shop since 1947.
              </span>
            </h2>
            <p className="text-secondary mb-8 max-w-md text-pretty" data-id="element-442">
              Pop in for a coffee and a chat. No appointment needed — though if
              you're coming about a custom ring, we'll set extra time aside for
              you.
            </p>

            <div className="space-y-6 mb-10" data-id="element-443">
              <div className="flex items-start gap-4 pb-5 border-b border-gold/15" data-id="element-444">
                <MapPinIcon className="w-5 h-5 text-gold shrink-0 mt-1" data-id="element-445" />
                <div data-id="element-446">
                  <p className="brand-mark text-[0.65rem] uppercase text-muted mb-1.5" data-id="element-447">
                    Address
                  </p>
                  <p className="text-primary leading-relaxed" data-id="element-448">
                    Shop 5&amp;6 Riseley Square
                    <br data-id="element-449" />
                    7–9 Riseley Street
                    <br data-id="element-450" />
                    Ardross WA 6153
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4 pb-5 border-b border-gold/15" data-id="element-451">
                <PhoneIcon className="w-5 h-5 text-gold shrink-0 mt-1" data-id="element-452" />
                <div data-id="element-453">
                  <p className="brand-mark text-[0.65rem] uppercase text-muted mb-1.5" data-id="element-454">
                    Phone
                  </p>
                  <a href="tel:0893162321" className="text-primary font-medium hover:text-gold-dark transition-colors" data-id="element-455">
                    08 9316 2321
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-456">
                <ClockIcon className="w-5 h-5 text-gold shrink-0 mt-1" data-id="element-457" />
                <div data-id="element-458">
                  <p className="brand-mark text-[0.65rem] uppercase text-muted mb-1.5" data-id="element-459">
                    Opening hours
                  </p>
                  <div className="text-primary leading-relaxed text-sm" data-id="element-460">
                    <div className="grid grid-cols-[auto_1fr] gap-x-6" data-id="element-461">
                      <span data-id="element-462">Monday – Friday</span>
                      <span className="text-secondary" data-id="element-463">9:00am – 4:30pm</span>
                      <span data-id="element-464">Saturday</span>
                      <span className="text-secondary" data-id="element-465">9:00am – 1:00pm</span>
                      <span data-id="element-466">Sunday</span>
                      <span className="text-muted" data-id="element-467">Closed</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex flex-wrap gap-3" data-id="element-468">
              <a href="https://maps.google.com/?q=Sinclairs+Jewellers+Ardross" target="_blank" rel="noopener noreferrer" className="btn-primary" data-id="element-469">
                <NavigationIcon className="w-4 h-4 mr-2 text-gold-light" data-id="element-470" />
                Get directions
              </a>
              <a href="tel:0893162321" className="btn-secondary" data-id="element-471">
                <PhoneIcon className="w-4 h-4 mr-2 text-gold" data-id="element-472" />
                Call the workshop
              </a>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.97
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.9
        }} className="lg:col-span-7 relative aspect-[5/4] lg:aspect-[6/5] bg-paper border border-gold/20 overflow-hidden" data-id="element-473">
            {/* Stylised map */}
            <div className="absolute inset-0" style={{
            backgroundImage: `
                linear-gradient(rgba(176, 130, 71, 0.08) 1px, transparent 1px),
                linear-gradient(90deg, rgba(176, 130, 71, 0.08) 1px, transparent 1px),
                linear-gradient(rgba(31, 42, 54, 0.04) 1px, transparent 1px),
                linear-gradient(90deg, rgba(31, 42, 54, 0.04) 1px, transparent 1px)
              `,
            backgroundSize: '60px 60px, 60px 60px, 15px 15px, 15px 15px'
          }} data-id="element-474" />

            {/* Diagonal roads */}
            <div className="absolute top-1/3 -left-10 right-0 h-2 bg-gold/25 rotate-[8deg] origin-left" data-id="element-475" />
            <div className="absolute top-2/3 -left-10 right-0 h-1 bg-burgundy/15 -rotate-[5deg] origin-left" data-id="element-476" />
            <div className="absolute left-1/3 top-0 bottom-0 w-1.5 bg-gold/20" data-id="element-477" />

            {/* Pin */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex flex-col items-center" data-id="element-478">
              <div className="relative" data-id="element-479">
                <div className="absolute inset-0 bg-gold/30 rounded-full animate-ping" data-id="element-480" />
                <div className="relative w-14 h-14 rounded-full bg-primary border-2 border-gold flex items-center justify-center" data-id="element-481">
                  <MapPinIcon className="w-5 h-5 text-gold-light" data-id="element-482" />
                </div>
              </div>
              <div className="mt-3 bg-background px-5 py-3 border border-gold/30 shadow-lg text-center min-w-[220px]" data-id="element-483">
                <p className="font-serif text-base text-primary leading-tight" data-id="element-484">
                  Sinclairs Jewellers
                </p>
                <p className="brand-mark text-[0.6rem] uppercase text-muted mt-1" data-id="element-485">
                  Riseley Square · Ardross
                </p>
              </div>
            </div>

            <div className="absolute bottom-4 right-4 text-[0.6rem] tracking-[0.25em] uppercase text-muted/60" data-id="element-486">
              [Live Google Map · Bricks embed]
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}